import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";
import { title } from "@core/utils/filter";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function useUsersList() {
  // Use toast
  const toast = useToast();

  const refUserListTable = ref(null);
  const refUpdateUsersModal = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "full_name", label: "المستخدم", sortable: true },
    { key: "email", label: "البريد الالكتروني", sortable: true },
    { key: "dob", label: "تاريخ الميلاد", sortable: true },
    { key: "governorate.name_ar", label: "المحافظة", sortable: true },
    { key: "is_blocked", label: "حساب محظور" },
    { key: "is_locked", label: "حساب مقفل" },
    { key: "actions", label: " " },
  ];

  const addNewUser = async (userData, isMinistry = false) => {
    await store
      .dispatch("Ministry/Settings/Users/addUser", { userData, isMinistry })
      .then((response) => {
        toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      })
      .catch((err) => {
        if (err !== 422)
          toast({
            component: ToastificationContent,
            props: {
              title: "حدث خطأ أثناء العملية",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
      });
  };
  const restoreUser = async (id, isMinistry = false) => {
    await store
      .dispatch("Ministry/Settings/Users/restoreUser", { id, isMinistry })
      .then((response) => {
        toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء العملية",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };
  const changeUserPassword = async (passwordData, isMinistry = false) => {
    await store
      .dispatch("Ministry/Settings/Users/changeUserPassword", {
        passwordData,
        isMinistry,
      })
      .then((response) => {
        toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء العملية",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const updateUser = async (userData, isMinistry = false) => {
    await store
      .dispatch("Ministry/Settings/Users/updateUser", { userData, isMinistry })
      .then((response) => {
        toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      })
      .catch((err) => {
        if (err !== 422)
          toast({
            component: ToastificationContent,
            props: {
              title: "حدث خطأ أثناء العملية",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
      });
  };

  const deleteUser = async (id, isMinistry = false) => {
    await store
      .dispatch("Ministry/Settings/Users/deleteUser", { id, isMinistry })
      .then((response) => {
        toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء العملية",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  return {
    tableColumns,
    refUserListTable,
    addNewUser,
    updateUser,
    deleteUser,
    refUpdateUsersModal,
    changeUserPassword,
    restoreUser,
    // Extra Filters
  };
}
